module.exports = __webpack_public_path__ + "static/media/Windows_Logo.d685b4e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Windows_Logo.svg
// module id = 472
// module chunks = 21